// 设置URL查询参数
export const setQuery = ({ url = window.location.href, list = [], force = false }) => {
    let resultUrl = url;

    try {
        const urlObj = new URL(url);
        const { searchParams } = urlObj;

        list.forEach(item => {
            const { key, value } = item;

            if (force) {
                searchParams.set(key, value);
            } else if (!searchParams.has(key)) {
                searchParams.append(key, value);
            }
        });

        resultUrl = urlObj.href;
    } catch (e) {
        console.error(e);
    }

    return resultUrl;
};

// 获取URL查询参数
export const getQuery = (url, key) => {
    let value = '';

    try {
        const urlObj = new URL(url);
        const { searchParams } = urlObj;

        if (searchParams.has(key)) {
            value = searchParams.get(key);
        }
    } catch (e) {
        console.error(e);
    }

    return value;
};

// 设置URL在客户端的标准查询参数
export const setAppQuery = url => {
    return setQuery({
        url,
        list: [{ key: 'isFull', value: '0' }, { key: 'immersion', value: 'true' }, { key: 'ifengsp', value: '1' }],
    });
};
// 设置URL在客户端的标准查询参数：无沉浸式
export const setAppQueryNoImmersion = url => {
    return setQuery({
        url,
        list: [{ key: 'isFull', value: '0' }, { key: 'ifengsp', value: '1' }],
    });
};

// 设置URL在客户端的标准查询参数：无标参
export const setAppQueryNoIfengsp = url => {
    return setQuery({
        url,
        list: [{ key: 'isFull', value: '0' }, { key: 'immersion', value: 'true' }, { key: 'needpage', value: '1' }],
    });
};
// 获取URL的查询参数
export const getSearchParam = key => {
    const search = window.location.search.replace('?', '');
    const kvList = search.split('&').map(item => item.split('='));
    const kv = kvList.find(item => item[0] === key);

    return kv && kv[1];
};

// 删除URL的查询参数
export const removeSearchParam = key => {
    const search = window.location.search.replace('?', '');
    const kvList = search.split('&').map(item => item.split('='));
    const fliterKvList = kvList.filter(item => item[0] !== key);

    return `${window.location.origin}${window.location.pathname}?${fliterKvList.map(item => item.join('=')).join('&')}`;
};

export const postCallClientUrl = id => {
    let transformUrl = '';

    if (id) {
        const baseUrl = `${window.location.origin}${window.location.pathname}`.replace('detail', 'list');

        transformUrl = `${baseUrl}${window.location.search}&communityId=${id}`;
    } else {
        transformUrl = location.href;
    }

    return transformUrl;
};
